import React from 'react';
import { Box, Card, CardContent, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

import { formatDate } from './approvalWorkflowFormatters';

export default function ApprovalAuditLogCard({ auditEntries }) {
    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Audit-Log
                </Typography>
                <Box sx={{ overflowX: 'auto' }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Zeitpunkt</TableCell>
                                <TableCell>Entität</TableCell>
                                <TableCell>Entitäts-ID</TableCell>
                                <TableCell>Aktion</TableCell>
                                <TableCell>Benutzer</TableCell>
                                <TableCell>Details</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {auditEntries.map((entry) => (
                                <TableRow key={entry.id}>
                                    <TableCell>{formatDate(entry.createdAt)}</TableCell>
                                    <TableCell>{entry.entityType}</TableCell>
                                    <TableCell>{entry.entityId || '-'}</TableCell>
                                    <TableCell>{entry.action}</TableCell>
                                    <TableCell>{entry.actorName || entry.actorId || '-'}</TableCell>
                                    <TableCell>{entry.details || '-'}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </CardContent>
        </Card>
    );
}
